<template>
  <v-alert
    v-if="message"
    type="error"
    border="left"
    text
    class="py-2 auth-login-alert"
    :data-testid="testId"
  >{{ message }}</v-alert>
</template>

<script>
export default {
  name: 'AuthLoginAlert',
  props: {
    message: { type: String, default: '' },
    testId: { type: String, default: 'login-sso__alert' },
  },
};
</script>

<style lang="scss" scoped>
@import './AuthLoginAlert.scss';
</style>
